import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { urlServer } from '../global_constants';
import { Referential } from '../models/referential';
import { ServiceResponse } from '../models/service-response';

@Injectable({
  providedIn: 'root'
})
export class CityService {

  baseUrl = urlServer.concat("/v1/ref/cities");
  cityUrl = urlServer.concat("/v1/city");
  citiesCustomersUrl = urlServer.concat("/v1/customers/maps");

  public get token() : string|null {
    if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) 
    return localStorage.getItem("token");
    return sessionStorage.getItem("token");
  }

  constructor(private httpClient:HttpClient) { }

  getCities() {
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.httpClient.get<ServiceResponse>(this.baseUrl, {headers: header});
  }

  addCity(city: Referential){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.httpClient.post<ServiceResponse>(this.cityUrl, city, {headers: header});
  }

  updateCity(city: Referential){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.httpClient.put<ServiceResponse>(this.cityUrl, city, {headers: header});
  }

  deleteCity(uuid: string){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.httpClient.delete<ServiceResponse>(`${this.cityUrl}/${uuid}`, {headers: header});
  }

  getPresentCitiesCustomers(){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.httpClient.get<ServiceResponse>(`${this.citiesCustomersUrl}`, {headers: header});
  }

}
